import styled from 'styled-components';

export const S = {
  Wrapper: styled.div`
    width: 850px;
    display: flex;
    justify-content: space-between;
    margin: 30px auto;
  `,
};
